import { restApiIP } from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApiIP.get("/api/slow-moving-inventory", { params });
};

const getAllForCSV = params => {
  params.nowDate = new ZDate();
  return restApiIP.get("/api/slow-moving-inventory/csv", { params });
};

const slowMovingInventoryService = {
  getAll,
  getAllForCSV
};

export default slowMovingInventoryService;